import { Seniority } from "../interfaces/ResourceInterfaces";
import { dateUtils } from "./dateUtils";

const calculateSeniorityFromFirstMissionDate = (
  firstMission: string
): Seniority => {
  if (!firstMission) return null;

  const firstMissionDate = new Date(firstMission);
  const seniorityInMonths = dateUtils.getNumberOfMonthsBetweenTwoDates(
    firstMissionDate,
    dateUtils.today()
  );
  return {
    years: seniorityInMonths >= 0 ? Math.floor(seniorityInMonths / 12) : Math.ceil(seniorityInMonths / 12),
    months: seniorityInMonths % 12,
  };
};

export const seniorityUtils = {
  calculateSeniorityFromFirstMissionDate
}
